import React, { useEffect, useState } from "react";
import FavMessagePopup from "./FavMessagePopup";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import ReactMarkdown from "react-markdown";
import PlotlyGraph from "../../components/layout/PlotlyGrapgh";
import Feedback from "../../components/feedback/Feedback";
import PushPinIcon from "@mui/icons-material/PushPin";
import Options from "./QueryOptions";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useMediaQuery } from "react-responsive";
import $ from 'jquery';
import { ArrowRight, RefreshCw } from "lucide-react";
const AnswerDisplay = ({
  item,
  index,
  printPDF,
  responseNumber,
  responseId,
  handlePin,
  pinError,
  isPinned,
  message,
  pinLoading,
  responceData,
  setResponceData
}) => {
  const [open, setOpen] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [openOptions, setOpenOptions] = useState(false);
  const [graphData,setGraphDataNew] = useState(item.figure)
  

  const handleExpandClick = (item) => {
    setCurrentMessage(item);
    setOpen(true);
  };

  function trimString(str, maxLength) {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + "...";
    }
    return str + " ...";
  }
  const getBackgroundColor = (score) => {
    const parsedScore = parseFloat(score);
    if (isNaN(parsedScore)) {
      return "red";
    }
    return parsedScore > 0.75
      ? "green"
      : parsedScore > 0.5
        ? "#FFC000"
        : "red";
  };
  const backgroundColor = getBackgroundColor(item.confidence_score);
  const isTab = useMediaQuery({ query: "(max-width: 768px)" });

  function formatDateString(dateString) {
    const date = new Date(dateString);

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    function getOrdinalSuffix(day) {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    }

    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
  }

  useEffect(()=>{
    $('.summary-text').each(function() {
      // Select all <p> tags inside current .summary-text element except the first one
      // $(this).find('p:not(:first-child)').remove();
      const paragraphs = $(this).find('p');
      $(this).children(':not(p, pre)').remove();

      // Check number of <p> tags
      if (paragraphs.length > 1) {
        // Remove all <p> tags except the first one
        paragraphs.slice(1).remove();
      }
    });
  },[])

  const question = message?.query ?? '';

  return (
    <div
      className="p-6 rounded "
      style={{border:"1px solid #eee",borderLeft:"4px solid #bb1ccc"}}
    >

      <div className="mobileLayout-width pb-3"   style={{  display:isTab ? "flex": "flex", width: "100%", justifyContent: item.header && isTab ?"space-between": "space-between", alignContent: "center", alignItems: "center" }}>
      <span className="font-bold text-[24px]">{item.header ? item.header : `Summary of ${question}`}</span>

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "flex-end",
              alignContent: "center",
              alignItems: "center",
              justifyItems: "center",
            }}
            className="mobile-score-layout"

          >
            {item.confidence_score !== undefined &&
              item.confidence_score !== "NA" && (
              <div
                style={{
                  backgroundColor: backgroundColor,
                  color:
                    parseFloat(item.confidence_score).toFixed(2) > 0.75
                      ? "white"
                      : parseFloat(item.confidence_score).toFixed(2) > 0.5
                        ? "black"
                        : "white",
                  padding: "7px",
                  borderRadius: "6px",
                  fontWeight: "600",
                }}
              >
                {parseFloat(item.confidence_score).toFixed(2)}
              </div>
            )}
          
            <div
              className={`three-dots-icon ${openOptions ? "option-active" : ""}`} 
              onClick={() => {
                setOpenOptions((prevState) => true);
              }}
            >
              <MoreVertIcon />
            </div>
          </div>
        </div>
      </div>

    
      <ReactMarkdown className="summary-text">
        {item.summary.toLowerCase() === "na"
          ? item.message
          : responseNumber > 1
            ? trimString(item.summary, 600)
            : item.summary}
      </ReactMarkdown>
      {item.summary && item.summary.toLowerCase() !== "na" && (
        <div className="flex gap-1 font-semibold align-center hideClass pt-0">
          {/* For more details and follow up questions click on{" "}
          <ArrowRight width={15} /> */}
          <p
            className="read-more-btn text-[#bb1ccc] font-bold cursor-pointer flex gap-2 "
            onClick={() => handleExpandClick(item)}
          >
            Read More <ArrowRight width={15} />
          </p>
        </div>
      )}

{graphData && (
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "auto",
            marginTop: "16px",
          }}
          className="plotly-cont"
        >
          <PlotlyGraph
            graph={graphData}
            childId={item.child_question_id}
            version={item.version ? item.version : 1}
            AnswerDisplay="AnswerDisplay"
            messageID={responseId}
            setResponceData={setResponceData}
            responceData={responceData}
            setGraphDataNew={setGraphDataNew}
          />
        </div>
      )}
      {/* {item?.LastUpdate && (
        <div
          style={{
            color: "#333",
            fontWeight: "600",
            fontSize: "12px",
            marginTop: "24px",
            textAlign: "left",
          }}
        >
          Last Refresh: {formatDateString(item?.LastUpdate)}
        </div>
      )} */}

      <div class="HideMoreInPrints">
        <>
        {item.from_cache && (
            <div className="pb-2 flex align-center gap-2 pb-2 text-gray-400 text-[14px]">
              This response may be from cache 
            </div>
           )} 
        {message && message.num_of_followup > 0 && (
            <span className="pb-2 block text-gray-400 text-[14px]">
              Number of follow up available is{" "}
              <b className="text-[#bb1ccc]">{message.num_of_followup}</b>{" "}
            </span>
          )}

{item?.LastUpdate && (
            <div
              style={{
                color: "#333",
                fontWeight: "600",
                fontSize: "12px",
                marginBottom: "12px",
              }}
            >
              Last Refresh: {formatDateString(item?.LastUpdate)}
            </div>
          )}
          <Feedback
            feedbackStatus={item.feedback ? item.feedback : ""}
            messageID={responseId}
            index={index}
            child_response_id={index}
          />
        </>
      </div>
      <FavMessagePopup
        open={open}
        setOpen={setOpen}
        // message={currentMessage}
        index={index}
        printPDF={printPDF}
        messageID={responseId}
        isPinned={isPinned}
        pinError={pinError}
        handlePin={handlePin}
        version={item.version ? item.version : 1}
        pinLoading={pinLoading}
        item={item}
        displayedLogs={message && message.logs.length > 0 ? message.logs : []}
        message={message}

      />{" "}
      {/* Pass the current message to the popup */}
      {openOptions && (
        <Options
          handleExpandClick={handleExpandClick}
          setOpenOptions={setOpenOptions}
          isPinned={isPinned}
          pinError={pinError}
          handlePin={handlePin}
          item={item}
          messageID={responseId}
          pinLoading={pinLoading}
        />
      )}
    </div>
  );
};

export default AnswerDisplay;
